import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { Formik } from "formik";
import { changePassword } from "../redux/actions/authActions";
import AuthLayout from "../layouts/Auth";

import {
  Button,
  Paper,
  TextField as MuiTextField,
  Typography,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { Alert as MuiAlert } from "@material-ui/lab";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

const Wrapper = styled(Paper)`
  padding: ${(props) => 6}px;

  ${(props) => "md"} {
    padding: ${(props) => 10}px;
  }
`;

function ChangePassword() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  return (
    <AuthLayout>
      <Wrapper>
        <Helmet title="Reset Password" />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Confirmar contraseña
        </Typography>
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
            submit: false,
          }}
          validationSchema={Yup.object().shape({
            password: Yup.string()
              .min(12, "Utiliza al menos 12 caracteres.")
              .max(64, "Utiliza un máximo de 64 caracteres.")
              .required("Campo requerido."),
            confirmPassword: Yup.string().when("password", {
              is: (val) => (val && val.length > 0 ? true : false),
              then: Yup.string().oneOf(
                [Yup.ref("password")],
                "Ambas contraseñas deben ser iguales."
              ),
            }),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              await dispatch(
                changePassword({
                  token: `${id}`,
                  password: values.password,
                  confirmPassword: values.confirmPassword,
                })
              );
              history.push("/auth/sign-in");
            } catch (error) {
              const message = error.message || "Something went wrong";

              setStatus({ success: false });
              setErrors({ submit: message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              {errors.submit && (
                <Alert mt={2} mb={1} severity="warning">
                  {errors.submit}
                </Alert>
              )}
              <TextField
                type="password"
                name="password"
                label="Contraseña"
                value={values.password}
                error={Boolean(touched.password && errors.password)}
                fullWidth
                helperText={
                  (touched.password && errors.password) ||
                  "Utiliza al menos 12 caracteres. Puedes escribir una frase fácil de recordar."
                }
                onBlur={handleBlur}
                onChange={handleChange}
                my={3}
              />
              <TextField
                type="password"
                name="confirmPassword"
                label="Confirmar Contraseña"
                value={values.confirmPassword}
                error={Boolean(
                  touched.confirmPassword && errors.confirmPassword
                )}
                fullWidth
                helperText={touched.confirmPassword && errors.confirmPassword}
                onBlur={handleBlur}
                onChange={handleChange}
                my={3}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Reiniciar contraseña
              </Button>
            </form>
          )}
        </Formik>
      </Wrapper>
    </AuthLayout>
  );
}

export default ChangePassword;
